<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...$$props}>
  <path
    d="M8.05 4.15039H9.91L4.67001 11.2504H21.75V12.7504H4.67001L9.91 19.8504H8.05L2.25 11.9904L8.05 4.15039Z"
    fill="currentColor"
  />
</svg>
